
import React, { useEffect, useState } from 'react';
import { Box, Card, Divider, TableBody, Typography, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import Paginator from "../../../toolkit/Paginator";
import { debounce } from 'lodash';

import axios from '../../../utils/fvAxios';
import { Autocomplete, } from '@mui/material';

import Status from "../../../stories/StatusComponent/status.json";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
//import Nodata from "../../../Nodata/Nodata";
import ExpiredVendorEmailPage from './ExpiredVendorEmailPage';
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import IconButton from '@mui/material/IconButton';
import CardContent from "@mui/material/CardContent";
import CloseIcon from '@mui/icons-material/Close';




export default function ExpiredVendor() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: "320px",
            },

        },
    };

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [dialogopen, setDialogOpen] = React.useState(false);
    const [spinner, setSpinner] = React.useState(false);
    const [VendorsForInviteList, setVendorsForInviteList] = React.useState([]);
    const [clientList, setClientList] = React.useState([]);
    const [clientId, setClientId] = React.useState("");
    const [LocationsList, setLocationsList] = React.useState([]);
    const [Search, setSearch] = React.useState("");
    const [Count, setCount] = useState("");
    const [number, setNumber] = useState("1");
    const [Info, setInfo] = useState({});
    const [Searchdebounce, setSearchdebounce] = useState("");
    const [Delay, setdelay] = useState(true);

    const DialogOpenClick = (r) => {
        setDialogOpen(true);
        setInfo(r);
    };
    const DialogCloseClick = () => {
        setDialogOpen(false);
    };

    useEffect(() => {
        Details();

        // setTimeout(() => {
        //     setdelay(false);
         
        // }, 4000);
    }, []);

    useEffect(() => {

        if (Search === Searchdebounce)
            return GetInformation();
    }, [number, clientId, Search, Searchdebounce,]);

    const delayedSearch = debounce((value) => {
        setSearchdebounce(value)
    }, 2000);

    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearch(value);
        delayedSearch(value);
    };

    const GetInformation = () => {
        setSpinner(true);
        if (clientId != "") {
            axios.get("AdminVendors/GetVendorsForInvite?pageNumber=" + number + "&pageSize=" + 12 + "&status=" + 0 + "&type=" + 0 + "&client=" + clientId + "&vendorName=" + Searchdebounce + "&ERIOnly=false")
                .then((res) => {
                    setVendorsForInviteList(res?.data?.data?.vendorData);
                    setCount(res?.data?.count);
                }).catch(err => {
                    console.log(err);
                }).finally(() => {
                    setTimeout(() => {
                    setSpinner(false);
                }, 5000);
                })
        }
    }

    async function Details() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
        setClientList(res?.data?.data);
        setClientId(res?.data?.data[0]?.value);
    }
    const ChangeClient = (i) => {
        setClientId(i);
        setNumber(1);
    }
    // const SpinnerClose = () => {
    //     setSpinner(false);
    // };
    const handlePageChange = (e) => {
        setNumber(e);
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
              
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Dialog
                fullScreen={fullScreen}
                open={dialogopen}
                onClose={DialogCloseClick}
            >    <div style={{ marginLeft: "auto" }}>
                    <span className='mx-2' onClick={DialogCloseClick} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
                </div>
                <ExpiredVendorEmailPage DialogClose={DialogCloseClick} Locations={LocationsList} ClientId={clientId} INFO={Info} />
            </Dialog>

            <Card>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <span style={{ color: "red" }} >This tab is for re-inviting vendors that are registered for your company, but whose prequalifications have expired. Click on the Vendor Name field and enter the company name, or just hit the Enter key to produce all names. Then click on the Invite Vendor link to enter values and invite. You can add vendor email addresses to the invitation if desired.</span>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
                <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                    <Stack spacing={2} direction="row">
                        <div style={{ padding: "10px" }}>
                            <TextField
                                placeholder='Search'
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    fontFamily: "Arial, FontAwesome"
                                }}
                                variant="outlined"
                                size="small"
                                value={Search || ""}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div style={{ marginLeft: "Auto", padding: "10px" }}>
                            <Select
                                sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                    width: "320px"
                                }}
                                labelId="demo-multiple-name-label"
                                value={clientId || ""}
                                id="demo-multiple-name"
                                size="small"
                                onChange={(e) => ChangeClient(e.target.value, "")}
                                MenuProps={MenuProps}
                            >
                                {clientList?.map((r, i) =>
                                    <MenuItem key={i} value={r?.value} > {r?.text}</MenuItem>
                                )}
                            </Select>
                        </div>
                    </Stack >

                </div>
                <Box sx={{ backgroundColor: '#f8f9fa' }}>
                    <>
                        {VendorsForInviteList?.length < 1 ?
                            <div hidden={spinner}>
                                
                                <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 2, marginRight: "13px", width: "100%" }} className="text-center">
                                    <span style={{ color: "#667085" }}>No Records found</span>
                                </Box>
                            </div> :
                            <>
                                <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                                    <Table aria-label="customized table">

                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Name</span></StyledTableCell>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Status</span></StyledTableCell>
                                                <StyledTableCell >&nbsp;</StyledTableCell>

                                            </TableRow>
                                        </TableHead>
                                        {VendorsForInviteList?.map((r, i) => (
                                            <TableBody key={i}>

                                                <TableRow key={i}>
                                                    <StyledTableCell sx={{ width: "20%" }}>
                                                        {r?.orgName}
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ width: "17%" }}>
                                                        <Card
                                                            style={{ backgroundColor: Status?.find((p) => p?.value == (r?.previousStatusDetails?.pqStatusId != 0 ? r?.previousStatusDetails?.pqStatusId : r?.currentStatusId))?.color, width: "fit-content", padding: "5px" }}>
                                                            <Typography sx={{ color: "#fff" }}>
                                                                <Stack direction={"row"} spacing={1}>
                                                                    <img
                                                                        src={Status?.find((p) => p?.value == (r?.previousStatusDetails?.pqStatusId != 0 ? r?.previousStatusDetails?.pqStatusId : r?.currentStatusId))?.imageUri}
                                                                        alt={r?.previousStatusDetails?.pqStatusId != 0 ? r?.previousStatusDetails?.pqStatusName + " - " + r?.currentStatus : r?.currentStatus}
                                                                        style={{ fontSize: "100px", width: "20px" }}
                                                                    />

                                                                    <span>{r?.previousStatusDetails?.pqStatusId != 0 ? r?.previousStatusDetails?.pqStatusName + " - " + r?.currentStatus : r?.currentStatus}</span>
                                                                </Stack>
                                                            </Typography>
                                                        </Card>
                                                    </StyledTableCell>
                                                    <StyledTableCell sx={{ width: "5%" }} >
                                                        <span style={{ color: "#2A93DB", cursor: "pointer" }} onClick={() => DialogOpenClick(r)}> <MailOutlineIcon /> {"Invite Vendor"}</span>
                                                    </StyledTableCell>
                                                </TableRow>

                                            </TableBody>
                                        ))}
                                    </Table>

                                </TableContainer>
                            </>
                        }
                    </>
                </Box >

            </Card >
            <div hidden={Count < 1}>
                <Paginator
                    count={Math.ceil(Count / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>


        </Box >
    );
}





